import { createColumnHelper } from "@tanstack/react-table";
import { DocNumberLink } from "@/modules/core/components/DocNumberLink";
import type { DeskTableFeatures } from "@/modules/shell/data-table";
import type { AuditEvent } from "@/shared/api/audit";
import { docLink } from "@/shared/doc-link";

const columnHelper = createColumnHelper<DeskTableFeatures, AuditEvent>();

export function auditEventColumns(companySlug: string) {
  return columnHelper.columns([
    columnHelper.accessor("createdAt", {
      id: "createdAt",
      header: "When",
      size: 170,
      cell: (info) =>
        new Date(info.getValue()).toLocaleString("en-PH", {
          timeZone: "Asia/Manila",
        }),
    }),
    columnHelper.accessor("label", {
      id: "label",
      header: "Event",
      size: 200,
      enableSorting: false,
      cell: (info) => {
        const e = info.row.original;
        const href =
          e.docType && e.docId
            ? docLink(companySlug, e.docType, e.docId)
            : null;
        if (href) {
          return (
            <DocNumberLink to={href} className="font-sans">
              {info.getValue()}
            </DocNumberLink>
          );
        }
        return <span className="font-medium">{info.getValue()}</span>;
      },
    }),
    columnHelper.accessor("action", {
      id: "action",
      header: "Action",
      size: 180,
      cell: (info) => (
        <span className="font-mono text-xs text-[var(--color-muted)]">
          {info.getValue()}
        </span>
      ),
    }),
    columnHelper.accessor("actorLabel", {
      id: "actorLabel",
      header: "Actor",
      size: 140,
      enableSorting: false,
    }),
    columnHelper.accessor("docType", {
      id: "docType",
      header: "Doc type",
      size: 130,
      cell: (info) => info.getValue()?.replaceAll("_", " ") ?? "—",
    }),
    columnHelper.accessor("summary", {
      id: "summary",
      header: "Summary",
      size: 200,
      enableSorting: false,
      cell: (info) => info.getValue() || "—",
    }),
  ]);
}
